import { useCallback } from "react";

function isAbortLikeErrorValue(error: unknown): boolean {
  if (!error) {
    return false;
  }

  if (typeof error === "string") {
    return (
      error.includes("The operation was aborted") ||
      error.includes("AbortError") ||
      error.includes("The user aborted a request") ||
      error.includes("signal is aborted")
    );
  }

  if (typeof error !== "object") {
    return false;
  }

  const candidate = error as {
    message?: string;
    name?: string;
    networkError?: unknown;
    reason?: unknown;
    cause?: unknown;
  };

  if (
    candidate.name === "AbortError" ||
    candidate.message?.includes("The operation was aborted") ||
    candidate.message?.includes("AbortError") ||
    candidate.message?.includes("The user aborted a request") ||
    candidate.message?.includes("signal is aborted")
  ) {
    return true;
  }

  return (
    isAbortLikeErrorValue(candidate.networkError) ||
    isAbortLikeErrorValue(candidate.reason) ||
    isAbortLikeErrorValue(candidate.cause)
  );
}

export default function useAbortLikeError() {
  return useCallback((error: unknown) => isAbortLikeErrorValue(error), []);
}

